//import React from 'react';
import { get, BASE_URL } from '../../src/client'; // 위에서 만든 apiClient.js 파일 가져오기
import {Homebanner} from '../model/homebanner';


export const gethomebanner = async () => {



  try {
    const responseBody = await get(BASE_URL, '/v1/boards/home-banners');
        console.log( responseBody);

    const homebannerArray = responseBody.map(item => {
            return new Homebanner(
            item.type,
            item.image,
            item.url,
            item.notice,
            );
        });

    return homebannerArray

    //return dailylooksArray
    // console.log(dailylooksArray[0].created_at)
    
    // console.log(dailylooksArray[2].more_images[0])
    // console.log(dailylooksArray[3].user.username)
    
    // localStorage.setItem('authToken', responseBody.access_token)
    // const savedToken = localStorage.getItem('authToken');
    // console.log(savedToken)

    // 로그인 성공 후 로직 추가:
    // 예: 토큰 저장, 사용자 정보 상태 업데이트, 페이지 이동 등
    // localStorage.setItem('authToken', responseBody.accessToken);

  } catch (error) {
    console.log( error.message == 'Request failed with status code 401');
    if(error.message == 'Request failed with status code 401'){
      return 'f'
    }
    // 에러에 따른 사용자 알림 표시 등
    return error.message
    
  }
};